import React from "react";

function Heading({ children }) {
  return <p className="font-[700]">{children}</p>;
}

export default Heading;
